<template>
  <b-modal
    ref="repeatedPatientsModal"
    :title="$t('globalLocator.sections.whatAreYouLookingFor')"
    centered
    modal-class="repeated-patients"
    hide-footer
  >
    <div class="mx-3">
      <b-row class="mb-2">
        <b-col class="header">
          <h4>{{ $t('component.patientFusion.repeatedIdentifiers') }}</h4>
          <span>{{ reasonForShowingModal }}</span>
        </b-col>
      </b-row>
      <b-row class="scroll-area">
        <b-col cols="12">
          <b-card
            v-for="(patient, i) in repeatedPatients"
            :key="i"
            class="py-1 repeated-patient-card mt-3"
            @click="selectPatient(patient)"
          >
            <b-row>
              <b-col
                cols="7"
                class="align-items-center d-flex"
              >
                <p style="margin: 0">
                  <i
                    class="main mr-2 fal fa-user-circle"
                    aria-hidden="true"
                  /><span class="dark">{{ patient.fullName }}</span>
                </p>
              </b-col>
              <template v-if="patient.centerIdentifier !== search">
                <b-col
                  v-for="(identifierType, indexIdentifierType) in Object.keys(patient.personIdentifiers)"
                  :key="indexIdentifierType"
                  class="id-column"
                >
                  <div v-if="patient.personIdentifiers[identifierType].identifier === search">
                    <small>{{ patient.personIdentifiers[identifierType].identifierTypeName }}</small>
                    <h4 class="collapsable-card-title inside">
                      {{ patient.personIdentifiers[identifierType].identifier }}
                    </h4>
                  </div>
                </b-col>
              </template>
              <template v-else>
                <b-col class="id-column">
                  <small>{{ patient.centerIdentifierType.name }}<i
                    v-tooltip="patient.centerIdentifierCenterName"
                    class="ml-1 far fa-clinic-medical"
                    aria-hidden="true"
                  /></small>
                  <h4 class="collapsable-card-title inside">
                    {{ patient.centerIdentifier }}
                  </h4>
                </b-col>
              </template>
              <b-col
                cols="1"
                class="d-flex align-items-center justify-content-end"
              >
                <i
                  class="far fa-chevron-right"
                  aria-hidden="true"
                />
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>

export default {
    name: 'ModalRepeatedPatients',
    props: {
        reasonForShowingModal: { type: String, default: function() { return this.$t('component.patientFusion.selectToApply') } }
    },
    data() {
        return {
            repeatedPatients: [],
            search: null
        }
    },
    methods: {
        show(patients, search) {
            this.search = search
            this.repeatedPatients = patients
            this.$refs.repeatedPatientsModal.show()
        },
        selectPatient(patient) {
            if (patient.patId) {
                this.$emit('patientSelected', patient)
            } else {
                this.$emit('patientSelectedFromHis', patient)
            }
            this.hide()
        },
        hide() {
            this.$refs.repeatedPatientsModal.hide()
        }
    }
}
</script>

<style lang="scss">
    .repeated-patients .header h4 {
        margin-bottom: 0;
    }
    .repeated-patients .scroll-area {
        height: calc(100vh - 600px);
        overflow-y: auto;
    }
    .repeated-patients .repeated-patient-card {
        box-shadow: 1px 1px 5px 0 rgba(125, 125, 125, 0.64);
        cursor: pointer;
        transition: .3s;
    }
    .repeated-patients .repeated-patient-card:hover {
        background: vt-color(light-primary) !important;
    }
    .repeated-patients .repeated-patient-card:hover i {
        color: vt-color(primary);
    }
    .repeated-patients .id-column {
        line-height: 13px;
    }
    .repeated-patients .modal-dialog {
        max-width: 35% !important;
    }
    @media (max-width: 1300px) {
        .repeated-patients .modal-dialog {
            max-width: 55% !important;
        }
    }
    @media only screen and (max-width: 1366px) and (min-width: 1360px) {
        .repeated-patients .modal-dialog {
            max-width: 40% !important;
        }
        .repeated-patients .scroll-area {
            height: calc(100vh - 500px);
        }
    }
</style>
